import {BREAKPOINT} from '@angular/flex-layout';

// Single source of truth for the desktop/mobile switch. Deliberately below 1280px:
// a 1920px wide screen at the Windows "recommended" 150% scaling renders at exactly
// 1280 CSS px, so a 1280px threshold leaves zero headroom and flips to mobile.
// Keep in sync with $screen-lg-min in src/styles/abstracts/_variables.scss.
export const DESKTOP_MIN_WIDTH = 1200;

export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH}px)`;

// 0.02px below the threshold so fractional viewport widths (produced by fractional OS
// scale factors) can never land in a gap where neither query matches.
const DESKTOP_MAX_WIDTH = DESKTOP_MIN_WIDTH - 0.02;

export function isDesktopWidth(): boolean {
	return window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
}

export const CUSTOM_BREAKPOINTS = [
	// { alias: 'xs', suffix: 'Xs', mediaQuery: '(max-width: 319px)', overlapping: false, priority: 1001 },
	// { alias: 'gt-xs', suffix: 'GtXs', mediaQuery: '(min-width: 320px)', overlapping: false, priority: 1001 },
	
	{ alias: 'xs', suffix: 'xs', mediaQuery: '(max-width: 374px)', overlapping: false, priority: 1001 },
	{ alias: 'gt-xs', suffix: 'Gtxs', mediaQuery: '(min-width: 375px)', overlapping: false, priority: 1001 }, 

	{ alias: 'sm', suffix: 'sm', mediaQuery: '(min-width: 375px) and (max-width: 689px)', overlapping: false, priority: 1001 },
	{ alias: 'lt-sm', suffix: 'LtSm', mediaQuery: '(max-width: 374px)', overlapping: false, priority: 1001 },
	{ alias: 'gt-sm', suffix: 'GtSm', mediaQuery: '(min-width: 690px)', overlapping: false, priority: 1001 }, 

	{ alias: 'smd', suffix: 'smd', mediaQuery: '(min-width: 690px) and (max-width: 767px)', overlapping: false, priority: 1001 },
	{ alias: 'lt-smd', suffix: 'LtSmd', mediaQuery: '(max-width: 689px)', overlapping: false, priority: 1001 },
	{ alias: 'gt-smd', suffix: 'GtSmd', mediaQuery: '(min-width: 768px)', overlapping: false, priority: 1001 },

	{ alias: 'md', suffix: 'md', mediaQuery: `(min-width: 768px) and (max-width: ${DESKTOP_MAX_WIDTH}px)`, overlapping: false, priority: 1001 },
	{ alias: 'lt-md', suffix: 'LtMd', mediaQuery: '(max-width: 767px)', overlapping: false, priority: 1001 },
	{ alias: 'gt-md', suffix: 'GtMd', mediaQuery: DESKTOP_MEDIA_QUERY, overlapping: false, priority: 1001 },

	{ alias: 'lg', suffix: 'lg', mediaQuery: `(min-width: ${DESKTOP_MIN_WIDTH}px) and (max-width: 1919px)`, overlapping: false, priority: 1001 },
	{ alias: 'lt-lg', suffix: 'LtLg', mediaQuery: `(max-width: ${DESKTOP_MAX_WIDTH}px)`, overlapping: false, priority: 1001 },
	{ alias: 'gt-lg', suffix: 'GtLg', mediaQuery: '(min-width: 1920px)', overlapping: false, priority: 1001 },

	{ alias: 'xl', suffix: 'xl', mediaQuery: '(min-width: 1920px)', overlapping: false, priority: 1001 },
	{ alias: 'lt-xl', suffix: 'LtXl', mediaQuery: '(max-width: 1919px)', overlapping: false, priority: 1001 }


];

export const CustomBreakPointsProvider = { 
  provide: BREAKPOINT,
  useValue: CUSTOM_BREAKPOINTS,
  multi: true
};